import { HarddiskIcon } from './HarddiskIcon';

/**
 * author: Austin Andrews
 * id 6CBB2398-E7ED-4A08-8489-1FFF87D0605C
 * name harddisk
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/harddisk.svg
 * tags
 */
export const HddIcon = HarddiskIcon;
export default HddIcon